import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { Topics } from "@common/interfaces/topics";
import { IID_EP_ASSET } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDepAssetsState extends EntityState<IID_EP_ASSET, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_EP_ASSETS , realtimeEntity: 'IID_EP_Asset'})
@InterfaceDataStore(InterfaceName.ASSETS)
export class IIDepAssetsStore extends EntityStore<IIDepAssetsState> {
  constructor() {
    super([]);
  }
}
